"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonHolds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const Formatters_1 = require("../../common/Formatters");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const AddHold_1 = __importDefault(require("./AddHold"));
const HoldStatusButton_1 = __importDefault(require("./HoldStatusButton"));
const ChangeHoldStatus_1 = __importDefault(require("./ChangeHoldStatus"));
const hui_1 = require("@mit/hui");
const react_2 = require("react");
const executeSortDesc = (a, b) => {
    const fieldName = "date";
    let dateTimeA = (0, Formatters_1.toDate)(a[fieldName]);
    let dateTimeB = (0, Formatters_1.toDate)(b[fieldName]);
    return dateTimeB.diff(dateTimeA);
};
const PersonHoldsComponent = ({ searchUser, covidNav, holds, mitId, roles }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    const [showHolds, setShowHolds] = (0, react_1.useState)(false);
    const [showEdit, setShowEdit] = (0, react_1.useState)(false);
    const [editRecord, setEditRecord] = (0, react_1.useState)();
    const editHoldStatusClose = () => {
        setEditRecord(undefined);
        setShowEdit(false);
    };
    const closeHolds = () => {
        setShowHolds(false);
    };
    (0, react_1.useEffect)(() => {
        if (mitId || (searchUser && searchUser.person)) {
            reloadPersonSymptoms();
        }
    }, [searchUser.person, mitId]);
    const reloadPersonSymptoms = () => {
        setIsLoading(true);
        MedicalApi_1.default.fetchPersonMedicalHolds(mitId ? mitId : searchUser.person.mitId).then((resp) => {
            if (resp.unauth) {
                setUnAuth(true);
            }
            else {
                holds.personHolds = resp.items ? resp.items : [];
                setIsLoading(false);
            }
        });
        setIsLoading(false);
    };
    const getClassName = (status) => {
        if (status.toLowerCase() === 'open') {
            return 'open-status';
        }
        else if (status.toLowerCase() === 'new') {
            return 'new-status';
        }
        return '';
    };
    const columns = [
        {
            id: "date",
            name: "Last Updated",
            sortable: true,
            formatter: (item) => {
                return (0, Formatters_1.usDateTime)(item.date);
            },
            options: {
                demandPopin: true,
                minWidth: 500,
                popinText: "Last Updated",
            },
            filterable: false,
        },
        {
            id: "updated_by",
            name: "Updated By",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 300,
                popinText: "Updated By",
            },
            filterable: false,
        },
        {
            id: "reason",
            name: "Reason",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 300,
                popinText: "Reason",
            },
            filterable: false,
        },
        {
            id: "comments",
            name: "Comment",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 500,
                popinText: "Comment",
            },
            filterable: false,
        },
        {
            id: "status",
            name: "Status",
            sortable: true,
            formatter: (item) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: getClassName(item.status) }, { children: item.status }))),
            options: {
                demandPopin: true,
                minWidth: 500,
                popinText: "Status",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    if (value !== null && value !== undefined && value !== "") {
                        return item.Action === value;
                    }
                    return true;
                },
            },
        },
    ];
    const actionButtons = [
        {
            icon: "edit",
            type: hui_1.ButtonType.Ghost,
            onClick: (e) => {
                setEditRecord(e);
                setShowEdit(true);
            },
            text: "",
            state: 0,
            padded: false,
        },
    ];
    const data = !holds.personHolds
        ? []
        : holds.personHolds.sort(executeSortDesc).map((hold, index) => {
            return Object.assign(Object.assign({}, hold), { updated_by: hold.updated_by ? hold.updated_by : hold.created_by, date: hold.updated_on ? hold.updated_on : hold.created_on, Action: ((0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ holds: holds }, { children: (0, jsx_runtime_1.jsx)(HoldStatusButton_1.default, { currentStatus: hold.status, person: hold, holdGuid: hold.hold_guid }) }))) });
        });
    if (unAuth)
        return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", Object.assign({ className: "medical-holds profile-table-headers" }, { children: "Medical Holds" })), (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied }), ";"] }));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h4", Object.assign({ className: "medical-holds profile-table-headers" }, { children: ["Medical Holds", (roles === null || roles === void 0 ? void 0 : roles.roles.includes('medical')) && covidNav && covidNav.features && covidNav.features["covid19.medical.put_on_hold"] && ((0, jsx_runtime_1.jsx)(AddHold_1.default, { person: { mitId: mitId ? mitId : searchUser.person.mitId, name: mitId ? "" : searchUser.person.displayName, kerberosId: mitId ? "" : searchUser.person.kerberosId } }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "person-detail-container" }, { children: (0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: data, isLoading: isLoading, actionButtons: actionButtons, sortStateOptions: {
                        enabled: true,
                        key: 'covid-medical-person-holds'
                    } }) })), (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ holds: holds }, { children: (0, jsx_runtime_1.jsx)(ChangeHoldStatus_1.default, { person: searchUser.person, show: showHolds, onClose: closeHolds }) })), (0, jsx_runtime_1.jsx)(ChangeHoldStatus_1.default, { show: showEdit, person: editRecord, onClose: editHoldStatusClose })] }));
};
exports.PersonHolds = (0, mobx_react_1.inject)("searchUser", "covidNav", "holds", "roles")((0, mobx_react_1.observer)(PersonHoldsComponent));
